import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import PendingIcon from '@mui/icons-material/Pending';
import PersonIcon from '@mui/icons-material/Person';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

import { DashboardGrid, DashboardCard, DashboardLink, CardTitle } from './common';

const SitterDashboard = () => {
  return (
    <DashboardGrid>
      <DashboardCard>
        <DashboardLink href="/jobs/offers">
          <LocalOfferIcon fontSize="large" sx={{ mb: 1 }} className={"rounded-icon"}/>
          <CardTitle>View Job offers</CardTitle>
        </DashboardLink>
      </DashboardCard>
      <DashboardCard>
        <DashboardLink href="/jobs/confirmed">
          <ConfirmationNumberIcon fontSize="large" sx={{ mb: 1 }} className={"rounded-icon"} />
          <CardTitle>Confirmed Jobs</CardTitle>
        </DashboardLink>
      </DashboardCard>
      <DashboardCard>
        <DashboardLink href="/jobs/completed">
          <AssignmentTurnedInIcon fontSize="large" sx={{ mb: 1 }} className={"rounded-icon"}/>
          <CardTitle>Completed Jobs</CardTitle>
        </DashboardLink>
      </DashboardCard>
      <DashboardCard>
        <DashboardLink href="/account/pending-funds">
          <PendingIcon fontSize="large" sx={{ mb: 1 }} className={"rounded-icon"}/>
          <CardTitle>Funds Pending</CardTitle>
        </DashboardLink>
      </DashboardCard>
      <DashboardCard>
        <DashboardLink href="/account/profile">
          <PersonIcon fontSize="large" sx={{ mb: 1 }} className={"rounded-icon"}/>
          <CardTitle>Profile</CardTitle>
        </DashboardLink>
      </DashboardCard>
      <DashboardCard>
        <DashboardLink href="/account/funds">
          <AccountBalanceWalletIcon fontSize="large" sx={{ mb: 1 }} className={"rounded-icon"}/>
          <CardTitle>Account Funds</CardTitle>
        </DashboardLink>
      </DashboardCard>
    </DashboardGrid>
  );
};

export default SitterDashboard;
